import { Divider, Stack, Typography } from '@mui/material';
import type { Provider, ResourceType } from '@repo/api-gw-sdk';

import { ResourcesSelectorAccordion } from './resourcesSelector';

import { useResourceIdentifiers } from '../queryBuilder/useResourceIentifiers';

export const ResourceSelectionManualOverridesEditor = ({
  description,
  includeResources,
  excludeResources,
  setIncludedResources,
  setExcludedResources,
  supportedProviders,
  supportedResourceTypes,
}: {
  description: string;
  includeResources: string[];
  excludeResources: string[];
  setIncludedResources: (includedResources: string[]) => void;
  setExcludedResources: (excludedResources: string[]) => void;
  supportedProviders?: Provider[];
  supportedResourceTypes?: ResourceType[];
}) => {
  const { data: allResources } = useResourceIdentifiers(
    supportedProviders,
    supportedResourceTypes
  );

  return (
    <Stack gap='32px' width='308px'>
      <Typography variant='h3'>Manual overrides</Typography>
      <Stack gap='24px' overflow='auto'>
        <Typography variant='body1'>{description}</Typography>
        <Stack gap='12px'>
          <ResourcesSelectorAccordion
            label='Included resources'
            description={`${includeResources.length} resources manually included${includeResources.length ? ':' : '.'}`}
            allResources={allResources?.resources ?? []}
            resources={includeResources}
            addResource={(resource) =>
              setIncludedResources([...includeResources, resource])
            }
            removeResource={(resource) =>
              setIncludedResources(
                includeResources.filter((r) => r !== resource)
              )
            }
          />
          <Divider />
          <ResourcesSelectorAccordion
            label='Excluded resources'
            description={`${excludeResources.length} resources manually excluded:`}
            allResources={allResources?.resources ?? []}
            resources={excludeResources}
            addResource={(resource) =>
              setExcludedResources([...excludeResources, resource])
            }
            removeResource={(resource) =>
              setExcludedResources(
                excludeResources.filter((r) => r !== resource)
              )
            }
          />
          <Divider />
        </Stack>
      </Stack>
    </Stack>
  );
};
